// Where this app's data comes from. ONE source of truth — four files used to
// hardcode the URL, so pointing the app somewhere else meant finding all four.
//
// WHY THIS THROWS INSTEAD OF DEFAULTING:
// The old fallback was the hosted project `dmhw`. From 1 Sept that project IS
// Rainmaker live (Ravi's ruling, 16 Jul). A silent default therefore means a
// missing env var quietly points a dev build at production — which is exactly
// the failure you'd only notice after writing to it. There is no safe guess
// here, so we don't guess: a missing var is a build that refuses to run.
//
// Vite inlines import.meta.env at BUILD time, so the values must exist wherever
// the bundle is built:
//   - local dev  -> apps/web/.env.local (gitignored; points at Docker :54331)
//   - Vercel     -> project env vars (set 16 Jul, currently the hosted project)

const url = import.meta.env.VITE_SANDBOX_URL as string | undefined;
const key = import.meta.env.VITE_SANDBOX_KEY as string | undefined;

if (!url || !key) {
  throw new Error(
    'Supabase config missing: set VITE_SANDBOX_URL and VITE_SANDBOX_KEY.\n' +
      'Local dev: apps/web/.env.local (Docker sandbox is http://127.0.0.1:54331).\n' +
      'Deploys: set them on the hosting project. This build refuses to guess, ' +
      'because the old default was the production database.',
  );
}

export const SUPABASE_URL: string = url;
export const SUPABASE_KEY: string = key;

/** True when pointed at the local Docker sandbox — safe to break things. */
export const IS_LOCAL_SANDBOX = /127\.0\.0\.1|localhost/.test(url);
